import { useMutation, useQueryClient } from 'react-query';

import {  sendOnboardingDocumentsRoute } from '@features/digitalOnboarding';
import axiosInstance from '@server/axiosInstance';
import { applicationDocsKey } from '@features/applicationsDocs';
import { Dispatch, SetStateAction } from 'react';
import { errorMessage } from '@features/applicationQuestions';

type useSendOnboardingDocumentsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useSendOnboardingDocuments = ({
  setErrorText,
}: useSendOnboardingDocumentsProps) => {
  const client = useQueryClient();
   const signedTemplatesKey = 'signedTemplates';
  const { mutate: sendOnboardingDocument, isLoading: isSendingOnboardingDocument } = useMutation({
    mutationFn: (variables: { application_id: number; }) =>
      axiosInstance
        .post(sendOnboardingDocumentsRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(applicationDocsKey);
        client.invalidateQueries(signedTemplatesKey);
        if (setErrorText) {
          setErrorText('');
        }
      } else {
        if (setErrorText) {
          setErrorText(data?.message || errorMessage);
        }
      }
    },
    onError: () => {
      if (setErrorText) {
        setErrorText(errorMessage);
      }
    },
  });

  return {
    sendOnboardingDocument,
    isSendingOnboardingDocument,
  };
};
